import { render, staticRenderFns } from "./infoselect.vue?vue&type=template&id=6cc201ea&scoped=true&"
import script from "./infoselect.vue?vue&type=script&lang=js&"
export * from "./infoselect.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=6cc201ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc201ea",
  null
  
)

export default component.exports